export default __webpack_public_path__ + "static/orangeloop-code-refactoring-nell-agile-tutti-i-vantaggi-50443b28eca07a7ea6c1a3363d14eb7f.jpg";